<template>
  <div id="app">
    <a-config-provider :locale="locale" >
      <a-spin size="large" :spinning="loadMainStatus" :delay="10">
          <transition name="app-fade" mode="out-in">
          <router-view />
        </transition>
      </a-spin>
    </a-config-provider>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: "App",
  data(){
    return {
      locale:zhCN
    }
  },
  computed: {
    ...mapGetters({
      loadMainStatus: "home/getLoadMainStatus",
    })
  },
  methods:{
    toHelp(){
      window.open(process.env.VUE_APP_WIKI_URL)
    }
  }
};
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  margin: 0;
  padding: 0;
}
.app-fade-enter {
  opacity: 0;
  transform: translate(0, 0px);
}
.app-fade-leave {
  opacity: 1;
  transform: translate(0, 0);
}
.app-fade-enter-active {
  transition: all ease 0.4s;
}
.app-fade-leave-active {
  transition: all ease 0.4s;
}

</style>



// WEBPACK FOOTER //
// src/App.vue